<template>
  <div class="home-container">
    <b-container>
      <b-row align-h="center">
        <b-col :sm="12" :md="12" :lg="10" :xl="8">
          <b-card class="selection-card">
            <template #header>
              <div class="text-center">
                <h4 class="mb-0">Consentement à la signification électronique des actes de commissaires de justice</h4>
                <p class="text-muted mb-0 small">SECURACT</p>
              </div>
            </template>
            
            <b-card-body class="p-3">
              <div class="text-center mb-3">
                <h5 class="mb-2">Choisissez une des options suivantes</h5>
              </div>
              
              <div class="selection-buttons">
                <b-button
                  variant="outline-primary"
                  size="lg"
                  class="selection-btn"
                  @click="navigateToEntreprise"
                >
                  <div class="fw-bold">Entreprise</div>
                  <div class="text-muted small">Personne morale de droit privé ou de droit public</div>
                </b-button>
                
                <b-button
                  variant="outline-primary"
                  size="lg"
                  class="selection-btn"
                  @click="navigateToBanque"
                >
                  <div class="fw-bold">Banque</div>
                  <div class="text-muted small">
                    Inscription réservée aux procédures de saisies sur comptes de dépôt<br />
                    <i>LOI n°2019-222 du 23 mars 2019 - art. 15</i><br />
                    <i>Art. L. 211-1-1. Du CPCE</i><br />
                  </div>
                </b-button>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'Home',
  methods: {
    navigateToEntreprise() {
      this.$router.push('/entreprise')
    },
    navigateToBanque() {
      this.$router.push('/banque')
    }
  }
}
</script>

<style scoped>
.home-container {
  padding: 10px 0;
}

.selection-card {
  border: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

.selection-buttons {
  display: flex;
  gap: 15px;
}

.selection-btn {
  flex: 1;
  padding: 15px;
  border-radius: 8px;
  border: 2px solid;
  transition: all 0.3s ease;
  text-align: center;
  cursor: pointer;
}

.selection-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);
  background-color: #f8f9ff !important;
  border-color: #007bff !important;
  color: #007bff !important;
}

.selection-btn:hover .text-muted {
  color: #6c757d !important;
}

.selection-btn .text-muted {
  font-size: 0.8rem;
}

.fw-bold {
  font-weight: bold !important;
}

@media (max-width: 768px) {
  .selection-buttons {
    flex-direction: column;
    gap: 10px;
  }
  
  .selection-btn {
    padding: 12px;
  }
}
</style> 